// actions.js
import { tokenutils } from '../../modules/login/actions'
import * as types from '../../modules/login/constants'

export const sessionExpired = () => (dispatch) => {
  console.log('Token expired, logging out')
  tokenutils.removeToken()
  dispatch({ type: types.USER_LOGOUT })
}
